import React from 'react';
import { Route, Switch } from 'react-router-dom';
import useCardsRoutingGuard from 'slices/Cards/hooks/useCardsRoutingGuard';
import useCardsAnalyticsRoutingGuard from 'slices/Cards/hooks/useCardsAnalyticsRoutingGuard';
import useCurrentUser from 'infrastructure/currentUser/useCurrentUser';
import { AnalyticsPage } from './Loadable';

export default () => {
  const { hasAnalyticsViewerPermissions } = useCurrentUser();
  useCardsRoutingGuard();
  useCardsAnalyticsRoutingGuard({
    redirectPath: hasAnalyticsViewerPermissions ? '/analytics' : '/stories',
  });

  return (
    <Switch>
      <Route path="/cards-analytics">
        <AnalyticsPage />
      </Route>
    </Switch>
  );
};
